import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import { Stack } from "PFComponents/containers";
import { Markdown } from "PFComponents/markdown";
import { Tile } from "PFComponents/tile";
import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

export const ActivityOverviewDescription = () => {
  const activity = useCurrentActivity();
  const { t } = useTranslation("activities");

  return (
    <Tile variant="light" paddingVariant="lg" qaId="ActivityDetailsDescription">
      <Stack>
        <Typography variant="h5">{t("show.details.description")}</Typography>
        <Markdown raw={activity.description} qaId="ActivityDetailsDescription-Content" emojify={false} />
      </Stack>
    </Tile>
  );
};
